import * as XLSX from '@e965/xlsx';

export function isExportDataArrayOfArrays(data) {
    return Array.isArray(data)
        && data.length > 0
        && data.every((row) => Array.isArray(row));
}

function cellDisplayLength(value) {
    if (value == null)
        return 0;
    if (value instanceof Date)
        return 19;
    if (typeof value === 'number')
        return String(value).length;
    if (typeof value === 'boolean')
        return value ? 4 : 5;
    return String(value).length;
}

export function fitWorksheetColumns(ws) {
    const ref = ws['!ref'];
    if (!ref)
        return;

    const range = XLSX.utils.decode_range(ref);
    const widths = [];

    for (let c = range.s.c; c <= range.e.c; c += 1) {
        let max = 8;
        for (let r = range.s.r; r <= range.e.r; r += 1) {
            const cell = ws[XLSX.utils.encode_cell({ r, c })];
            if (!cell)
                continue;
            max = Math.max(max, cellDisplayLength(cell.v));
        }
        widths.push({ wch: Math.min(max + 1, 60) });
    }

    ws['!cols'] = widths;
}

export function buildWorksheetFromExportData(data) {
    const ws = isExportDataArrayOfArrays(data)
        ? XLSX.utils.aoa_to_sheet(data)
        : XLSX.utils.json_to_sheet(data);

    if (ws['!ref'])
        ws['!autofilter'] = { ref: ws['!ref'] };

    fitWorksheetColumns(ws);
    return ws;
}

export function buildXlsxArrayBuffer(data) {
    const ws = buildWorksheetFromExportData(data);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    return XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellDates: true });
}

function safeSheetName(name, fallback) {
    const raw = String(name || fallback || 'data')
        .replace(/[:\\/?*[\]]/g, ' ')
        .trim() || 'data';
    return raw.slice(0, 31);
}

export function buildXlsxWorkbookArrayBuffer(sheets) {
    const wb = { Sheets: {}, SheetNames: [] };
    (sheets || []).forEach((sheet, index) => {
        const baseName = safeSheetName(sheet?.name, `data ${index + 1}`);
        let name = baseName;
        let suffix = 1;
        while (wb.Sheets[name]) {
            const tail = ` ${suffix}`;
            name = `${baseName.slice(0, 31 - tail.length)}${tail}`;
            suffix += 1;
        }
        wb.Sheets[name] = buildWorksheetFromExportData(sheet?.data || []);
        wb.SheetNames.push(name);
    });

    if (wb.SheetNames.length === 0) {
        wb.Sheets.data = buildWorksheetFromExportData([]);
        wb.SheetNames.push('data');
    }

    return XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellDates: true });
}
